export class AwaitLock {
	private acquired = false;
	private waitingResolvers: Array<() => void> = [];

	acquire(): Promise<void> {
		if (!this.acquired) {
			this.acquired = true;
			return Promise.resolve();
		}

		return new Promise(resolve => {
			this.waitingResolvers.push(resolve);
		});
	}

	release(): void {
		if (!this.acquired) {
			console.error("Trying to release an unacquired lock");
		}

		if (this.waitingResolvers.length > 0) {
			let resolve = this.waitingResolvers.shift();
			if (resolve) {
				resolve();
			}
		}
		else {
			this.acquired = false;
		}
	}
}
